export default __webpack_public_path__ + "static/media/iconesFornecedoresMaior.dc43037e.png";